var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSurveyLeftbarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2660_15648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.56226 0.889957C5.42823 0.971223 4.33921 1.36652 3.4171 2.03159C2.49499 2.69667 1.77619 3.60527 1.34116 4.65568C0.90614 5.7061 0.772066 6.85686 0.953949 7.97915C1.13583 9.10144 1.62649 10.151 2.37101 11.0102L6.56226 6.81808V0.889957ZM7.43726 0.889957V6.56171H13.109C13.0036 5.09233 12.3722 3.71015 11.3305 2.66848C10.2888 1.6268 8.90663 0.995387 7.43726 0.889957ZM13.109 7.43671H7.18088L2.98963 11.628C3.8489 12.3722 4.89834 12.8627 6.02049 13.0444C7.14265 13.2261 8.29324 13.092 9.3435 12.657C10.3938 12.222 11.3022 11.5033 11.9673 10.5814C12.6323 9.65941 13.0276 8.57057 13.109 7.43671ZM-0.000244141 6.99921C-0.000244141 5.14269 0.737254 3.36221 2.05001 2.04946C3.36276 0.736705 5.14324 -0.000793457 6.99976 -0.000793457C8.85627 -0.000793457 10.6367 0.736705 11.9495 2.04946C13.2623 3.36221 13.9998 5.14269 13.9998 6.99921C13.9998 8.85572 13.2623 10.6362 11.9495 11.949C10.6367 13.2617 8.85627 13.9992 6.99976 13.9992C5.14324 13.9992 3.36276 13.2617 2.05001 11.949C0.737254 10.6362 -0.000244141 8.85572 -0.000244141 6.99921Z",
    fill: "#212529"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2660_15648"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyLeftbarIcon);
export default __webpack_public_path__ + "static/media/survey_leftbar_icon.2fe2745cafc7e343d25fd3462568a3db.svg";
export { ForwardRef as ReactComponent };